// src/components/FooterSection.js
import "./footerSection.css";
import React, { forwardRef } from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";

const FooterSection = forwardRef((props, ref) => {
	return (
		<footer ref={ref} className="footer">
			<div className="footer-left">
				{/*<h2 className="footer-left-title">Saffron House</h2>*/}
				<img
					className="footer-left-title"
					src="/images/saffronhouselogo.png"
					alt="Description of the image"
				/>
				<div className="footer-left-address">
					<div className="footer-address-item">
						<LocationOnIcon className="footer-address-icon" />
						<span>412 Skye Privilion, Nipania</span>
					</div>
					<div className="footer-address-item">
						<PhoneIcon className="footer-address-icon" />
						<span>+91 7000758077</span>
					</div>
				</div>
				<p className="footer-left-copyright">
					2025 Saffron House. All Rights Reserved. <br></br> <br></br>
					Developed By - {/*<br></br>*/}
					<a
						href="https://arvitech.in/"
						target="_blank"
						rel="noopener noreferrer"
					>
						ARVI Technologies And Consultation
					</a>
				</p>
			</div>
			<div className="footer-divider-wrapper">
				<div className="footer-divider"></div>
			</div>
			<div className="footer-right">
				<div className="footer-cta">
					<h3 className="footer-cta-title">Let's talk about Interiors!</h3>
					<p className="footer-cta-subtitle">
						We’re here to bring your interior visions to life.
					</p>
					<div>
						<button
							className="footer-button"
							onClick={() =>
								window.open("https://wa.me/917000758077", "_blank")
							}
						>
							Contact Us
							<ArrowOutwardIcon className="footer-button-icon"></ArrowOutwardIcon>
						</button>
					</div>
				</div>
				<div className="footer-cta">
					<h3 className="footer-cta-title">Get to Know Us Better</h3>
					<p className="footer-cta-subtitle">
						Explore our latest designs and enjoy behind-the-scenes moments.
					</p>
					<div>
						<button
							className="footer-button"
							onClick={() =>
								window.open(
									"https://www.instagram.com/_saffronhouse/",
									"_blank"
								)
							}
						>
							Follow Us on Instagram
							<ArrowOutwardIcon className="footer-button-icon"></ArrowOutwardIcon>
						</button>
					</div>
				</div>
			</div>
		</footer>
	);
});

export default FooterSection;